import DocumentStore from "../store/DocumentStore"
export default class RenderAudio {
    public static renderAudio(documentStore: DocumentStore) {
        documentStore.documentContentsSignal.value = [];
    }
}